import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

// import storage from "redux-persist/lib/storage";
import cartReducer from "./cartSlice";
import viewReducer from "./shopSlice";
import productReducer from "./productSlice";
import filtersReducer from "./filtersSlice";
import authReducer from "./authSlice";
import singleProductReducer from "./single-productSlice";
import OrdersHistory from "./ordersSlice";
import InvoicesReducer from "./invoicesSlice";
import PaymentReducer from "./paymentSlice";
const persistConfig = {
  key: "root",
  version: 1,
  storage: storageSession,
};

const persistedReducer = persistReducer(persistConfig, cartReducer);

export const store = configureStore({
  reducer: {
    cartReducer: persistedReducer,
    view: viewReducer,
    products: productReducer,
    filters: filtersReducer,
    auth: authReducer,
    singleproduct: singleProductReducer,
    orders: OrdersHistory,
    invoices: InvoicesReducer,
    payment: PaymentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export let persistor = persistStore(store);
